import { BASE_CONFIG } from 'projects/commons/src/public-api';
import { environment } from '../../environments/environment';

export const CONFIG = {
  ...BASE_CONFIG,
  apiPath: environment.apiPath,
  storagePrefix: 'os',
  isDevEnv: !environment.production
};
